<template lang="pug">
ul.menu-button-wrapper
	li.menu-button-container(:class="{ 'active': open }")
		.menu-button(@click="toggleOpen")
			.line-1
			.line-2
			.line-3
		transition(name="slide-down")
			.menu(v-show="open")
				ul
					li(v-if="show('map')"): a(href="/") Map
					li(v-if="show('report')"): a(href="/#Reports") Reports
					li(v-if="show('analysis')"): a(href="/#Analysis") Analysis
					li(v-if="show('config')"): a(href="/#Config") Config
					li(v-if="show('forms')"): a(href="/#Forms") Forms
					li(v-if="show('flood_dss')"): a(href="/Client/FloodStatus") Flood Status
					li(v-if="show('total_stations')"): a(href="/Client/DeviceManager") Total Stations
					li(v-if="show('fleet_management')"): a(href="/Client/FleetTracker") Fleet Management
					li(v-if="show('vu_feed')"): a(href="/Client/VUFeed") TFM-VU Feed					
					li(v-if="show('vu_history')"): a(href="/Client/VUHistory") TFM-VU History
					li(v-if="show('tfr_entry') && checkLegacyTFRFeatureFlag"): a(href="/TFREntry") TFR Entry
					li(v-if="(show('MOT') || show('tfr_entry'))&& !checkLegacyTFRFeatureFlag"): a(href="/Client/TFlowRestriction") T-Flow Restriction
					li(v-else-if="show('worker_presence')"): a(href="/Client/WorkerPresence") TFR Worker Presence
					li(v-if="show('MOT') && checkLegacyTFRFeatureFlag"): a(href="/Client/MOT") TFR MOT
					li(v-if="show('system_change_requests')"): a(href="/Client/ChangeRequests") System Change Requests
					li(v-if="show('dashboard')"): a(href="/Client/Dashboard") Dashboard
					li(v-if="show('user_profile')"): a(href="/UserSetup") User Profile
					li(v-if="show('contact')"): a(href="/Client/ContactUs") Contact Us
					li(v-if="show('help')"): a(href="/Client/Help") Help
					//- li: a(href="/#About") About
					li(v-if="show('logout')" @click="logout()"): a(href="/Account/Logout") Logout
					li(v-if="show('login')" ): a(href="/") Login
</template>

<script>
import PERMISSIONS from "@/common/permissions-lib";
export default {
	data() {
		return {
			open: false
		};
	},
	computed: {
		isLoggedIn() {
			return this.$store.getters.isLoggedIn;
		},
		checkLegacyTFRFeatureFlag() {
			return this.$mhi.userHasFeature(this.$mhi.LEGACY_TFR_ENTRY);
		},
		checkWPFeatureFlag() {
			return this.$mhi.userHasFeature(this.$mhi.WORKER_PRESENCE);
		}
	},
	watch: {
		open: function(newValue) {
			if (newValue === true) {
				this.bodyEventListenerAdd();
			} else {
				this.bodyEventListenerRemove();
			}
		}
	},
	destroyed() {
		this.bodyEventListenerRemove();
	},
	methods: {
		bodyEventListenerAdd() {
			window.document.body.addEventListener("click", this.onBodyClick);
		},
		bodyEventListenerRemove() {
			window.document.body.removeEventListener("click", this.onBodyClick);
		},
		hasRole(role) {
			return this.$store.getters.currentUserHasRole(role);
		},
		isInsideMenu(event) {
			return this.$el.contains(event.target);
		},
		onBodyClick(event) {
			const isInsideMenu = this.isInsideMenu(event);
			if (!isInsideMenu) {
				this.open = false;
			}
		},
		show(menuItemShortCode) {
			switch (menuItemShortCode) {
				case "map":
					return (
						this.hasRole(PERMISSIONS.TFM_VIEW) ||
						this.hasRole(PERMISSIONS.MPD_VEHICLE_TAB)
					);
				case "report":
					return this.hasRole(PERMISSIONS.MPD_REPORTS_TAB);
				case "analysis":
					return this.hasRole(PERMISSIONS.MPD_ANALYSIS_TAB);
				case "config":
					return this.hasRole(PERMISSIONS.VIDAS_CONFIG_VIEW);
				case "forms":
					return this.hasRole(PERMISSIONS.MPD_FORM_TAB);
				case "flood_dss":
					return this.$mhi.userHasFeature(this.$mhi.FLOOD_DSS);
				case "total_stations":
					return this.hasRole(PERMISSIONS.TOTAL_STATION_VIEW);
				case "vu_feed":
					return this.hasRole(PERMISSIONS.RSU_VU_TEST_VIEW);
				case "vu_history":
					return this.hasRole(PERMISSIONS.RSU_VU_TEST_VIEW);
				case "tfr_entry":
					return this.hasRole(PERMISSIONS.TFR_VIEW);
				case "system_change_requests":
					return this.hasRole(PERMISSIONS.SCR_VIEW);
				case "dashboard":
					return (
						this.$mhi.userHasFeature(this.$mhi.DASHBOARD) &&
						(this.hasRole(PERMISSIONS.TOTAL_STATION_VIEW) ||
							this.hasRole(PERMISSIONS.TSC_VIEW) ||
							this.hasRole(PERMISSIONS.ESS_VIEW) ||
							this.hasRole(PERMISSIONS.RSU_VIEW))
					);
				case "user_profile":
					return this.hasRole(PERMISSIONS.USER_SETUP_VIEW);
				case "contact":
					return true;
				case "MOT":
					return this.hasRole(PERMISSIONS.MOT_VIEW);
				case "worker_presence":
					return this.hasRole(PERMISSIONS.WP_VIEW) && this.checkWPFeatureFlag;
				case "fleet_management":
					return this.$mhi.userHasFeature(this.$mhi.FLEET_MANAGEMENT);
				case "help":
					return this.isLoggedIn && this.hasRole(PERMISSIONS.HELP_VIEW);
				case "logout":
					return this.isLoggedIn;
				case "login":
					return !this.isLoggedIn;
				default:
					return false;
			}
		},
		toggleOpen() {
			this.open = !this.open;
		},
		logout() {
			window.localStorage.removeItem("tabCloseCount");
		}
	}
};
</script>

<style lang="stylus">
.menu-button-wrapper
	display flex
	justify-content center
	align-items center

.menu-button-container
	display flex
	position relative
	padding 0.5em 0.25em

	&.active
		.menu-button
			background $dark-bg-color

.menu-button-container ul
	list-style none
	margin 0
	padding 0

.menu-button
	background $brand-color
	width 2em
	border-radius 5px
	position relative
	cursor pointer
	transition all linear .2s
	padding 3px
	z-index 2051
	cursor pointer

.line-1, .line-2, .line-3
	width 90%
	background #fff
	height 4px
	margin 3px auto
	border-radius 2px
	transition all cubic-bezier(0.68, -0.55, 0.265, 1.55) .3s
	cursor pointer

.menu-button-container.active .line-1
	-webkit-transform translate(0px,7px) rotate(45deg)
	transform translate(0px,7px) rotate(45deg)

.menu-button-container.active .line-2
	opacity 0

.menu-button-container.active .line-3
	-webkit-transform translate(0px, -7px) rotate(-45deg)
	transform translate(0px, -7px) rotate(-45deg)

.menu
	left 0px
	width 230px
	color #fff
	position absolute
	top -0.5em
	border-bottom-right-radius 5px
	z-index 2050
	background $dark-bg-color
	padding 0
	padding-top 2.75em
	font-size 18px
	transform-origin top left
	transition all 0.2s ease
	box-shadow 0px 1px 5px rgba(0, 0, 0, 0.5)
	text-align left
	max-height calc(100vh + 0.5em)
	overflow-y auto

.menu ul
	position relative
	list-style none

.menu ul li
	cursor pointer
	width 100%
	border solid 1px transparent

.menu ul li a
	display block
	padding 0.5em 0.5em
	transition background 0.2s ease

	&:hover
		background $brand-color

.menu ul li, .menu ul li a
	transition all 0.3s ease

.slide-down-enter, .slide-down-leave-to
	transform scaleY(0)
</style>
